import Empresa from './Empresa';

export default Empresa;